import React, { useState } from 'react'
import paymentSuccess from '../../assests/images/grenTick.png'
import paymentFailed from '../../assests/images/payment_failed.png'
import { useParams, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import paymentIMge from '../../assests/images/rb_27000.png'
import { useQueryClient } from "@tanstack/react-query";
function NowPaymentStatus() {
    const navigate = useNavigate()
    const [paymentStatus, setpaymentStatus] = useState(1)
    const { status } = useParams()
    const { t } = useTranslation()
    const queryClient = useQueryClient();
    const backTodashbaord = () => {
        queryClient.invalidateQueries({ queryKey: ["dashboard-user-profile", true] })
        navigate('/dashboard')
    }
    return (
        <div style={{ position: 'relative', width: '100%', height: '100%' }}>
            <section className="paymentstatus">
                <div className="container centerDiv">
                    <div className="loginBgImg"></div>
                    <div className="loginBg">
                        <div className="row">
                            <div className="col-md-6 logincredDetail">
                                <div className="loginFormSec login_left_section">
                                    <div className="loginLogo">
                                        <img src={status == "success" ? paymentSuccess : paymentFailed} alt="" className='w-50' />
                                        {status == "success"
                                            ?
                                            <h2>{t('payment_successfull')}</h2>
                                            :
                                            <h1>{t('payment_failed')}</h1>

                                        }
                                    </div>
                                    {
                                        status == "success" ?
                                            <>
                                                {/* <p>{t('payment_short_para')} 
                                                <span style={{ display: 'block' }}>{t('nested_para')}</span></p> */}

                                            </>

                                            :
                                            <p>{t('payment_failed_info')} </p>
                                    }

                                    <center>
                                        <button
                                            type="button"
                                            className="btn btn-labeled  mt-3"
                                            onClick={backTodashbaord}
                                            style={{ background: '#018290', color: 'white' }}
                                        >


                                            <i class="fa-solid fa-arrow-left"></i> {""}
                                            {t("backTodashboard")}




                                        </button>
                                    </center>
                                    <div className="loginFormSec"></div>


                                </div>

                            </div>
                            <div className="col-md-6">
                                <div className="welcomeImgSec">
                                    <div className="welcomHeadSec">

                                    </div>
                                    <div className="welcomeImg">
                                        <img src={paymentIMge} alt="" />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default NowPaymentStatus